import { DermloopUserRoleEnum } from '@dermloop/static-values';
import {
  IsBoolean,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { type MedicalUnitDto } from './medical-unit.dtos';
import { type MedicalUnitGroupDto } from './medical-unit-group.dtos';

export class CreateUserRoleDto {
  @IsEnum(DermloopUserRoleEnum)
  role: DermloopUserRoleEnum;

  @IsString()
  @IsNotEmpty()
  @IsUUID()
  userId: string;

  @IsOptional()
  @IsString()
  medicalUnitId: string;

  @IsOptional()
  @IsBoolean()
  readonly?: boolean;
}

export class UpdateUserRoleDto {
  @IsBoolean()
  readonly: boolean;
}

export class UserRoleDto {
  @IsUUID()
  id: string;

  @IsEnum(DermloopUserRoleEnum)
  role: DermloopUserRoleEnum;

  @IsOptional()
  @IsString()
  @IsUUID()
  userId?: string;

  @IsOptional()
  @ValidateNested()
  medicalUnit?: MedicalUnitDto;

  @IsOptional()
  @IsUUID()
  medicalUnitId?: string;

  @IsOptional()
  @ValidateNested()
  medicalUnitGroup?: MedicalUnitGroupDto;

  jurisdictionalGroupId?: string;

  federationId?: string;

  readonly?: boolean;
}
